<template>
  <div class="app-container">
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('productSeckill.queryCondition') }}</span>
      </div>
      <div class="">
        <el-form :inline="true" :model="productSeckillManageInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-input v-model="productSeckillManageInfo.conditions.prodName"
              :placeholder="$t('productSeckill.selectProductName')" style="width:100%" />
          </el-form-item>
          <el-form-item>
            <el-select v-model="productSeckillManageInfo.conditions.killHours"
              :placeholder="$t('productSeckill.selectKillHours')" style="width:100%">
              <el-option v-for="index in 24" :key="index" :label="`${index - 1}点`" :value="index - 1" />
              <el-option :label="$t('productSeckill.selectKillHours')" value="" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="productSeckillManageInfo.conditions.state"
              :placeholder="$t('productSeckill.selectStatus')" style="width:100%">
              <el-option :label="$t('productSeckill.selectStatus')" value="" disabled />
              <el-option :label="$t('productSeckill.open')" value="1001" />
              <el-option :label="$t('productSeckill.close')" value="2002" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="_queryProductSeckillMethod">
              {{ $t('productSeckill.query') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('productSeckill.seckillProducts') }}</span>
        <el-button type="primary" size="small" style="float:right" @click="_openAddProductSeckillModal">
          {{ $t('productSeckill.add') }}
        </el-button>
      </div>
      <el-table :data="productSeckillManageInfo.productSeckills" border style="width:100%">
        <el-table-column prop="coverPhoto" :label="$t('productSeckill.productImage')" align="center" width="100">
          <template slot-scope="scope">
            <el-image style="width:50px;height:50px;border-radius:10px"
              :src="scope.row.coverPhoto || '/img/noPhoto.jpg'" fit="cover" />
          </template>
        </el-table-column>
        <el-table-column prop="prodName" :label="$t('productSeckill.productName')" align="center" width="200" />
        <el-table-column prop="killHours" :label="$t('productSeckill.killHours')" align="center" />
        <el-table-column prop="continueHours" :label="$t('productSeckill.continueHours')" align="center" />
        <el-table-column prop="totalCount" :label="$t('productSeckill.validPurchase')" align="center" />
        <el-table-column prop="oneCount" :label="$t('productSeckill.onePurchaseCount')" align="center" />
        <el-table-column prop="killPrice" :label="$t('productSeckill.killPrice')" align="center">
          <template slot-scope="scope">
            ￥{{ scope.row.killPrice }}
          </template>
        </el-table-column>
        <el-table-column prop="price" :label="$t('productSeckill.singlePrice')" align="center">
          <template slot-scope="scope">
            ￥{{ scope.row.price }}
          </template>
        </el-table-column>
        <el-table-column prop="killStock" :label="$t('productSeckill.limit')" align="center" />
        <el-table-column prop="state" :label="$t('productSeckill.status')" align="center">
          <template slot-scope="scope">
            {{ scope.row.state === '1001' ? $t('productSeckill.open') : $t('productSeckill.close') }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('productSeckill.validPeriod')" align="center" width="200">
          <template slot-scope="scope">
            {{ scope.row.startTime }}~{{ scope.row.endTime }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('productSeckill.operation')" align="center" width="200">
          <template slot-scope="scope">
            <el-button size="mini" @click="_openEditProductSeckillModel(scope.row)">
              {{ $t('productSeckill.edit') }}
            </el-button>
            <el-button size="mini" type="danger" @click="_openDeleteProductSeckillModel(scope.row)">
              {{ $t('productSeckill.delete') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :current-page="productSeckillManageInfo.conditions.page"
        :page-size="productSeckillManageInfo.conditions.row" :total="productSeckillManageInfo.total"
        layout="total, prev, pager, next" @current-change="handleCurrentChange" />
    </el-card>

    <add-product-seckill ref="addProductSeckill" @refresh="_listProductSeckills" />
    <edit-product-seckill ref="editProductSeckill" @refresh="_listProductSeckills" />
    <delete-product-seckill ref="deleteProductSeckill" @refresh="_listProductSeckills" />
  </div>
</template>

<script>
import { listProductSeckill } from '@/api/group/productSeckillApi'
import AddProductSeckill from '@/components/group/addProductSeckill/addProductSeckill'
import EditProductSeckill from '@/components/group/editProductSeckill/editProductSeckill'
import DeleteProductSeckill from '@/components/group/deleteProductSeckill/deleteProductSeckill'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'ProductSeckillManage',
  components: {
    AddProductSeckill,
    EditProductSeckill,
    DeleteProductSeckill
  },
  data() {
    return {
      productSeckillManageInfo: {
        productSeckills: [],
        total: 0,
          records:1,
        conditions: {
          prodName: '',
          killHours: '',
          state: '',
          shopId: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this.productSeckillManageInfo.conditions.shopId = getShopId()
    this._listProductSeckills()
  },
  methods: {
    async _listProductSeckills() {
      try {
        const res = await listProductSeckill(this.productSeckillManageInfo.conditions)
        this.productSeckillManageInfo.productSeckills = res.data
        this.productSeckillManageInfo.total = res.total
          this.productSeckillManageInfo.records = res.records
      } catch (error) {
        console.error(error)
      }
    },
    _queryProductSeckillMethod() {
      this.productSeckillManageInfo.conditions.page = 1
      this._listProductSeckills()
    },
    _openAddProductSeckillModal() {
      this.$refs.addProductSeckill.open()
    },
    _openEditProductSeckillModel(row) {
      this.$refs.editProductSeckill.open(row)
    },
    _openDeleteProductSeckillModel(row) {
      this.$refs.deleteProductSeckill.open(row)
    },
    handleCurrentChange(val) {
      this.productSeckillManageInfo.conditions.page = val
      this._listProductSeckills()
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-container {
  padding: 20px;
}

.box-card {
  margin-bottom: 20px;
}
</style>